import DividerBox from './DividerBox';

export default DividerBox;
